interface TicketCommentNotificationProps {
  identifier: string;
  preview: string;
}

export function TicketCommentNotification({ identifier, preview }: TicketCommentNotificationProps) {
  return (
    <div className="mx-4 my-2 rounded-md bg-primary/5 px-3 py-2">
      <div className="flex items-center gap-2 text-caption">
        <span className="font-medium text-primary">Comment posted on {identifier}</span>
      </div>
      {preview && (
        <p className="mt-1 text-caption text-muted-foreground line-clamp-2">{preview}</p>
      )}
    </div>
  );
}
